export const GET_PM_LIST = 'GET_PM_LIST'
export const SET_PM_LIST = 'SET_PM_LIST'
export const SET_MULTIPLE_PM_LISTS = 'SET_MULTIPLE_PM_LISTS'
export const SET_PM_LIST_ERROR = 'SET_PM_LIST_ERROR'
export const SET_PM_LIST_PROCESSING = 'SET_PM_LIST_PROCESSING'
export const RESET_PM_LIST = 'RESET_PM_LIST'

export function getPmList (options = {}) {
  const { listId, language } = options
  return {
    type: GET_PM_LIST,
    payload: { listId, language },
  }
}

export function setPmList (options = {}) {
  const { listId, data, processing = false } = options
  return {
    type: SET_PM_LIST,
    payload: { listId, data, processing },
  }
}

export function setMultiplePmLists (options = {}) {
  const { lists, processing = false } = options
  return {
    type: SET_MULTIPLE_PM_LISTS,
    payload: { lists, processing },
  }
}

export function setPmListError (listId, error) {
  return {
    type: SET_PM_LIST_ERROR,
    payload: { listId, error },
  }
}

export function setPmListProcessing (listId, processing = true) {
  return {
    type: SET_PM_LIST_PROCESSING,
    payload: { listId, processing },
  }
}

export function resetPmList () {
  return {
    type: RESET_PM_LIST,
  }
}
